var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarOutline = function SvgStarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M47.447 33.418 40 10.5l-7.446 22.918H8.456l19.495 14.164L20.505 70.5 40 56.336 59.495 70.5 52.05 47.582l19.495-14.164zm17.941 2H45.994L40 16.972l-5.993 18.446H14.612l15.69 11.4-5.993 18.446L40 53.864l15.691 11.4-5.993-18.446z",
    clipRule: "evenodd"
  })));
};
export default SvgStarOutline;